<template>
    <div class="clause">
        <div class="container">
            <breadcrumbs :dom="crumbsItem" />
            <div class="text-center">
                <h3>服務條款</h3>
            </div>
            <div class="htmltext" v-dompurify-html="policy.Content"></div>
        </div>
    </div>
</template>

<script>
    import Breadcrumbs from '@/components/partial/Breadcrumbs'
    import policyApi from '@/api/policy'

    export default {
        data() {
            return {
                crumbsItem: [{
                        text: '首頁',
                        to: {
                            name: 'home'
                        },
                    },
                    {
                        text: '服務條款',
                        active: true
                    }
                ],
                policy: [],
            }
        },
        components: {
            Breadcrumbs,
        },
        created() {
            policyApi.policyType((data) => {
                this.policy = data ? data : []
            });
        },
        mounted() {
            this.createMetaTag();
        },
        destroyed() {
            const metaTags = document.querySelectorAll('meta[property^="og:"]');
            metaTags.forEach((metaTag) => {
              metaTag.parentNode.removeChild(metaTag);
            });
        },
        methods: {
            createMetaTag() {
                let currentDomain = window.location.hostname;
                let logoUrl = require(`@/assets/images/icon/logo_2020.png`)
                // Create new meta tags
                const metaImage = document.createElement('meta');
                metaImage.setAttribute('property', 'og:image');
                metaImage.setAttribute('content', 'https://' + currentDomain + logoUrl);
                document.head.appendChild(metaImage);

                const metaTitle = document.createElement('meta');
                metaTitle.setAttribute('property', 'og:title');
                metaTitle.setAttribute('content', '服務條款 - 特力屋玩體驗享生活手作DIY課程報名');
                document.head.appendChild(metaTitle);

                const metaDescription = document.createElement('meta');
                metaDescription.setAttribute('property', 'og:description');
                metaDescription.setAttribute('content', '「服務條款」載明會員權益及特力屋提供手作、體驗課程之主要服務範疇。並有「隱私權保護」相關政策說明。');
                document.head.appendChild(metaDescription);
            }
        }
    }
</script>
